module.exports = __webpack_public_path__ + "static/media/kids_22.bfac75c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_22.jpg
// module id = 5878
// module chunks = 0